import {ReactNode, useEffect} from 'react';
import {MainLayout} from "./MainLayout.tsx";
import AccountPageNav from "../account/AccountPageNav.tsx";
import {NotificationStatus} from "../notification/Notification.tsx";
import {useAuth} from "../../hooks/useAuth.tsx";
import {useLocation, useNavigate} from "react-router-dom";
import {useNotification} from "../../providers/NotificationProvider.tsx";

interface Props {
    children: ReactNode;
}

const AccountLayout = ({children}: Props) => {
    const _authService = useAuth();
    const _location = useLocation();
    const _navigate = useNavigate();
    const _notification = useNotification();

    useEffect(() => {
        if (!_authService.isRefreshTokenAvailable) {
            _navigate(`/logowanie?redirectTo=${_location.pathname}`);
            _notification.showNotification("Brak dostępu", "Zaloguj się, aby uzyskać dostęp.", NotificationStatus.failure);
        }
    }, [_authService.isRefreshTokenAvailable, _location, _navigate, _notification]);
    return (
        <MainLayout contentPadding={"px-0 pb-4 pt-14 md:pt-0"}>
            <AccountPageNav/>
            <div className={"mt-2 md:mt-0 md:pt-4 flex-1 flex flex-col mb-4"}>
                <div className={"animate-opacityEaseIn flex-1 px-2"}>
                    {children}
                </div>
            </div>
        </MainLayout>
    );
};

export default AccountLayout;